module.exports = __webpack_public_path__ + "components/outside-promo-page/static/bottompanel-7d83d348503bf5033f262b05a28ea756.webp";